import { FiFlag } from 'react-icons/fi';

interface Props {
    statusFilter: string;
    priorityFilter: '' | 'true' | 'false';
    onStatusChange: (status: string) => void;
    onPriorityChange: (priority: '' | 'true' | 'false') => void;
    statusCounts: Record<string, any>;
    priorityCounts: { priority: number; notPriority: number };
}

const STATUSES = [
    { value: 'DONE', label: 'Concluído' },
    { value: 'PARTIALLY_VALIDATED', label: 'Parcialmente validada' },
    { value: 'NOT_STARTED', label: 'Não iniciado' },
];

const DraweeConfirmationFilterSidebar = ({ statusFilter, priorityFilter, onStatusChange, onPriorityChange, statusCounts, priorityCounts }: Props) => {
    const cnt = (key: string): number => { const v = statusCounts[key]; return !v ? 0 : typeof v === 'object' ? v.count : v; };
    const totalAll = Object.values(statusCounts).reduce((a: number, b: any) => a + (typeof b === 'object' ? b.count : (b || 0)), 0);

    return (
        <div className="space-y-4">
            <button onClick={() => { onStatusChange(''); onPriorityChange(''); }}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${!statusFilter && !priorityFilter
                    ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-medium'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                <div className="flex items-center justify-between">
                    <span>Todos</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">{totalAll}</span>
                </div>
            </button>

            <div className="border-t border-gray-200 dark:border-slate-700 pt-3">
                <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 px-3">STATUS</div>
                <div className="space-y-1">
                    {STATUSES.map(s => (
                        <button key={s.value} onClick={() => onStatusChange(s.value)}
                            className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${statusFilter === s.value
                                ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-medium'
                                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                            <div className="flex items-center justify-between">
                                <span>{s.label}</span>
                                <span className="text-xs text-gray-500 dark:text-gray-400">{cnt(s.value)}</span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            <div className="border-t border-gray-200 dark:border-slate-700 pt-3">
                <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 px-3">PRIORIDADE</div>
                <div className="space-y-1">
                    <button onClick={() => onPriorityChange(priorityFilter === 'true' ? '' : 'true')}
                        className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${priorityFilter === 'true'
                            ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 font-medium'
                            : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <FiFlag className="text-red-500" size={13} />
                                <span>Prioritários</span>
                            </div>
                            <span className="text-xs text-gray-500 dark:text-gray-400">{priorityCounts.priority}</span>
                        </div>
                    </button>
                    <button onClick={() => onPriorityChange(priorityFilter === 'false' ? '' : 'false')}
                        className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${priorityFilter === 'false'
                            ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-medium'
                            : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                        <div className="flex items-center justify-between">
                            <span>Não prioritários</span>
                            <span className="text-xs text-gray-500 dark:text-gray-400">{priorityCounts.notPriority}</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DraweeConfirmationFilterSidebar;
